import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a1a99f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ac" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_submit_approval_btn = _resolveComponent("submit-approval-btn")!
  const _component_agree_btn = _resolveComponent("agree-btn")!
  const _component_reject_btn = _resolveComponent("reject-btn")!
  const _component_cancel_btn = _resolveComponent("cancel-btn")!
  const _component_void_btn = _resolveComponent("void-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSubmitFlg)
      ? (_openBlock(), _createBlock(_component_submit_approval_btn, {
          key: 0,
          loading: _ctx.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
          onRefresh: _ctx.refreshApprovalDetail,
          "biz-type": _ctx.bizType,
          "biz-id": _ctx.bizId,
          "biz-name": _ctx.bizName,
          class: "margin-left-14px"
        }, null, 8, ["loading", "onRefresh", "biz-type", "biz-id", "biz-name"]))
      : _createCommentVNode("", true),
    (_ctx.showAgreeFlg)
      ? (_openBlock(), _createBlock(_component_agree_btn, {
          key: 1,
          loading: _ctx.loading,
          "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
          onRefresh: _ctx.refreshApprovalDetail,
          "biz-type": _ctx.bizType,
          "biz-id": _ctx.bizId,
          class: "margin-left-14px"
        }, null, 8, ["loading", "onRefresh", "biz-type", "biz-id"]))
      : _createCommentVNode("", true),
    (_ctx.showRejectFlg)
      ? (_openBlock(), _createBlock(_component_reject_btn, {
          key: 2,
          loading: _ctx.loading,
          "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
          onRefresh: _ctx.refreshApprovalDetail,
          "biz-type": _ctx.bizType,
          "biz-id": _ctx.bizId,
          class: "margin-left-14px"
        }, null, 8, ["loading", "onRefresh", "biz-type", "biz-id"]))
      : _createCommentVNode("", true),
    (_ctx.showCancelFlg)
      ? (_openBlock(), _createBlock(_component_cancel_btn, {
          key: 3,
          loading: _ctx.loading,
          "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loading) = $event)),
          onRefresh: _ctx.refreshApprovalDetail,
          "biz-type": _ctx.bizType,
          "biz-id": _ctx.bizId,
          class: "margin-left-14px"
        }, null, 8, ["loading", "onRefresh", "biz-type", "biz-id"]))
      : _createCommentVNode("", true),
    (!_ctx.notShowVoid)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          (_ctx.showVoidBtn && !_ctx.existRelation && !_ctx.disabledVoid)
            ? (_openBlock(), _createBlock(_component_void_btn, {
                key: 0,
                loading: _ctx.loading,
                "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loading) = $event)),
                onRefresh: _ctx.refreshApprovalDetail,
                "biz-type": _ctx.bizType,
                "biz-id": _ctx.bizId,
                "biz-name": _ctx.bizName,
                class: "margin-left-14px"
              }, null, 8, ["loading", "onRefresh", "biz-type", "biz-id", "biz-name"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}